import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'cream-dark' | 'brown' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-[#FAF8F5]',
    'cream-dark': 'bg-[#F5F0E8]',
    brown: 'bg-[#3D2314] text-[#FAF8F5]',
    white: 'bg-white'
  };
  return <section id={id} className={`py-20 md:py-28 px-4 md:px-8 ${backgrounds[background]} ${className}`} data-id="element-116">
      <div className="max-w-7xl mx-auto" data-id="element-117">{children}</div>
    </section>;
}
export function SectionHeader({
  title,
  subtitle,
  centered = true,
  light = false
}: {
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}) {
  return <div className={`mb-16 ${centered ? 'text-center' : ''}`} data-id="element-118">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className={`text-3xl md:text-5xl font-bold mb-4 ${light ? 'text-[#FAF8F5]' : 'text-[#3D2314]'}`} data-id="element-119">
        {title}
      </motion.h2>
      <motion.div initial={{
      opacity: 0,
      width: 0
    }} whileInView={{
      opacity: 1,
      width: 100
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className={`h-1 bg-[#C9A227] mb-6 ${centered ? 'mx-auto' : ''}`} data-id="element-120" />
      {subtitle && <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.3
    }} className={`text-lg md:text-xl max-w-2xl ${centered ? 'mx-auto' : ''} ${light ? 'text-[#E0D8D0]' : 'text-[#5C3D2E]'}`} data-id="element-121">
          {subtitle}
        </motion.p>}
    </div>;
}